import React from 'react';

// Base wrapper keeps every sidebar glyph on the same 17x17 canvas.
const SidebarIcon = ({ children }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {children}
  </svg>
);

export const HomeIcon = () => (
  <SidebarIcon>
    <path
      d="M2.83334 8.02776L8.50001 2.83331L14.1667 8.02776M4.72223 7.08331V14.1666H12.2778V7.08331"
      stroke="white"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SidebarIcon>
);

export const BackrrPageIcon = () => (
  <SidebarIcon>
    <path
      d="M6.13888 7.55554H7.08333M6.13888 10.3889H7.08333M9.91666 7.55554H10.8611M9.91666 10.3889H10.8611M3.77777 14.6389V4.7222L8.49999 2.83331L13.2222 4.7222V14.6389H3.77777Z"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SidebarIcon>
);

export const RoundsIcon = () => (
  <SidebarIcon>
    <path
      d="M8.5 14.7333C11.9426 14.7333 14.7333 11.9426 14.7333 8.5C14.7333 5.05742 11.9426 2.26666 8.5 2.26666C5.05742 2.26666 2.26666 5.05742 2.26666 8.5C2.26666 11.9426 5.05742 14.7333 8.5 14.7333Z"
      stroke="white"
      strokeWidth="1.3"
    />
    <path d="M8.5 4.0611V12.9389V4.0611Z" fill="black" />
    <path
      d="M8.5 4.0611V12.9389"
      stroke="white"
      strokeWidth="1.15"
      strokeLinecap="round"
    />
    <path
      d="M10.4833 6.13891C10.0111 5.38335 9.30279 5.0528 8.50001 5.0528C7.4139 5.0528 6.51667 5.61946 6.51667 6.56391C6.51667 8.64168 10.4833 7.65002 10.4833 9.96391C10.4833 10.9556 9.58612 11.7111 8.50001 11.7111C7.60279 11.7111 6.84723 11.2861 6.46945 10.5306"
      stroke="white"
      strokeWidth="1.15"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SidebarIcon>
);

export const InvestorPipelineIcon = () => (
  <SidebarIcon>
    <path
      d="M2.83334 3.77777H14.1667L9.91668 8.97222V14.1667L7.08334 12.2778V8.97222L2.83334 3.77777Z"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SidebarIcon>
);

export const PerformanceMetricsIcon = () => (
  <SidebarIcon>
    <path
      d="M3.77777 14.1667V8.02777M8.49999 14.1667V3.77777M13.2222 14.1667V9.91666"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </SidebarIcon>
);

export const DataRoomsIcon = () => (
  <SidebarIcon>
    <path
      d="M2.83334 5.66667C2.83334 5.41619 2.93285 5.17597 3.10996 4.99885C3.28708 4.82173 3.52731 4.72223 3.77779 4.72223H7.08334L8.50001 6.42223H14.1667C14.4172 6.42223 14.6574 6.52173 14.8345 6.69885C15.0116 6.87597 15.1111 7.11619 15.1111 7.36667V13.2222C15.1111 13.4727 15.0116 13.7129 14.8345 13.8901C14.6574 14.0672 14.4172 14.1667 14.1667 14.1667H3.77779C3.52731 14.1667 3.28708 14.0672 3.10996 13.8901C2.93285 13.7129 2.83334 13.4727 2.83334 13.2222V5.66667Z"
      stroke="white"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </SidebarIcon>
);

export const CapTableIcon = () => (
  <SidebarIcon>
    <path
      d="M8.50001 14.5445C11.8383 14.5445 14.5445 11.8383 14.5445 8.50001C14.5445 5.16176 11.8383 2.45557 8.50001 2.45557C5.16176 2.45557 2.45557 5.16176 2.45557 8.50001C2.45557 11.8383 5.16176 14.5445 8.50001 14.5445Z"
      stroke="white"
      strokeWidth="1.3"
    />
    <path
      d="M8.5 8.50001V2.45557C10.1031 2.45557 11.6405 3.09239 12.7741 4.22594C13.9076 5.3595 14.5444 6.89692 14.5444 8.50001H8.5Z"
      fill="white"
    />
  </SidebarIcon>
);

export const InvestorUpdatesIcon = () => (
  <SidebarIcon>
    <path
      d="M12.8445 4.25H4.15557C3.42532 4.25 2.83334 4.84198 2.83334 5.57222V11.4278C2.83334 12.158 3.42532 12.75 4.15557 12.75H12.8445C13.5747 12.75 14.1667 12.158 14.1667 11.4278V5.57222C14.1667 4.84198 13.5747 4.25 12.8445 4.25Z"
      stroke="white"
      strokeWidth="1.3"
    />
    <path
      d="M3.30554 5.19446L8.49999 9.44446L13.6944 5.19446"
      stroke="white"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </SidebarIcon>
);

export const InvestorNetworkIcon = () => (
  <SidebarIcon>
    <path
      d="M6.61113 8.31112C7.81081 8.31112 8.78335 7.33858 8.78335 6.1389C8.78335 4.93921 7.81081 3.96667 6.61113 3.96667C5.41144 3.96667 4.4389 4.93921 4.4389 6.1389C4.4389 7.33858 5.41144 8.31112 6.61113 8.31112Z"
      stroke="white"
      strokeWidth="1.3"
    />
    <path
      d="M2.36111 14.1667V12.75C2.36111 11.9985 2.65963 11.2779 3.19098 10.7465C3.72233 10.2152 4.443 9.91666 5.19445 9.91666H8.02778C8.77923 9.91666 9.4999 10.2152 10.0313 10.7465C10.5626 11.2779 10.8611 11.9985 10.8611 12.75V14.1667"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <path
      d="M11.8055 6.79999C11.8999 6.7929 11.9946 6.7929 12.0889 6.79999C12.5898 6.79999 13.0703 6.60099 13.4245 6.24675C13.7788 5.89252 13.9778 5.41207 13.9778 4.91111C13.9778 4.41014 13.7788 3.92969 13.4245 3.57546C13.0703 3.22122 12.5898 3.02222 12.0889 3.02222M12.2778 10.0111H13.0333C13.7186 10.0797 14.3555 10.3956 14.8248 10.8997C15.2941 11.4038 15.5638 12.0615 15.5833 12.75V14.1667"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </SidebarIcon>
);

export const AIInsightsIcon = () => (
  <SidebarIcon>
    <path
      d="M7.55557 2.83334L8.78334 6.32779L12.2778 7.55557L8.78334 8.78334L7.55557 12.2778L6.32779 8.78334L2.83334 7.55557L6.32779 6.32779L7.55557 2.83334Z"
      stroke="white"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 10.8611L13.3167 12.4667L14.9222 13.0333L13.3167 13.6L12.75 15.2056L12.1833 13.6L10.5778 13.0333L12.1833 12.4667L12.75 10.8611Z"
      fill="white"
    />
  </SidebarIcon>
);

// Open book — the two pages meet at a central spine.
export const ResourcesIcon = () => (
  <SidebarIcon>
    <path
      d="M8.5 5.19446C7.55556 4.25001 6.13889 3.77779 3.77778 3.77779V12.2778C6.13889 12.2778 7.55556 12.75 8.5 13.6944"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 5.19446C9.44444 4.25001 10.8611 3.77779 13.2222 3.77779V12.2778C10.8611 12.2778 9.44444 12.75 8.5 13.6944"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 5.19446V13.6944"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </SidebarIcon>
);

export const SettingsIcon = () => (
  <SidebarIcon>
    <path
      d="M8.5 10.7667C9.75185 10.7667 10.7667 9.75185 10.7667 8.5C10.7667 7.24815 9.75185 6.23333 8.5 6.23333C7.24816 6.23333 6.23334 7.24815 6.23334 8.5C6.23334 9.75185 7.24816 10.7667 8.5 10.7667Z"
      stroke="white"
      strokeWidth="1.3"
    />
    <path
      d="M8.5 2.36111V4.25M8.5 12.75V14.6389M2.36111 8.5H4.25M12.75 8.5H14.6389M4.15556 4.15556L5.47778 5.47778M11.5222 11.5222L12.8444 12.8444M12.8444 4.15556L11.5222 5.47778M5.47778 11.5222L4.15556 12.8444"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </SidebarIcon>
);

export const BillingPlanIcon = () => (
  <SidebarIcon>
    <path
      d="M13.2222 4.25H3.77778C2.99538 4.25 2.36111 4.88426 2.36111 5.66667V11.3333C2.36111 12.1157 2.99538 12.75 3.77778 12.75H13.2222C14.0046 12.75 14.6389 12.1157 14.6389 11.3333V5.66667C14.6389 4.88426 14.0046 4.25 13.2222 4.25Z"
      stroke="white"
      strokeWidth="1.3"
    />
    <path d="M2.36111 7.08333H14.6389H2.36111Z" fill="black" />
    <path d="M2.36111 7.08333H14.6389" stroke="white" strokeWidth="1.3" />
  </SidebarIcon>
);
